import React from 'react';

import logoutIcon from '../../../assets/icons/header/oneInformBar/logout.svg';

interface LogoutProps {
    isLoading: boolean;
    onClick: () => void;
}

const Logout: React.FC<LogoutProps> = ({ isLoading, onClick }) => {
    return (
        <div
            onClick={!isLoading ? onClick : undefined}
            className={`flex items-center pl-[10px] md:pl-[17px] h-[20px] cursor-pointer hover:text-gray-200 transition-colors text-white ${isLoading ? 'opacity-50' : ''}`}
            title={isLoading ? 'Logging out...' : 'Logout'}
        >
            <img src={logoutIcon} alt="Logout" className="w-6 h-6 md:w-[20px] md:h-[20px]" />
        </div>
    );
};

export default Logout;
